import  React, {useEffect} from "react";
import * as request from 'superagent';
import { useState, useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {Button, AppBar, Toolbar, ButtonGroup, Grid, Badge, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList} from '@mui/material';
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked'
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { getValueAtPath, interpolateAction } from '~common/form/helper';
import {cloneDeep} from 'lodash'

import {DataContext, ActionContext} from "~common/form/icg-definition-data-provider";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: '100%'
        },
        paper: {
            padding: 8
        },
        appbar: {
            flexGrow: 1,
            top: 5,
            zIndex: 999,
            position: 'relative'
        },
        toolbar: {
            border: "1px solid #dedede",
            backgroundColor: "#eee"
        },
        toolbarMinimal: {
        display: "flex",
        justifyContent: "flex-end"
        },
        actionButton: {
            width: 120,
            marginLeft: theme.spacing ? theme.spacing() : 0,
            "&:first-child": {
                marginLeft: "0px !important;",
                minWidth: 'fit-content',
            },
            whiteSpace: 'nowrap',
            
        }, 
        actionButtonComplex: {
            width: 135,
            marginLeft: theme.spacing ? theme.spacing() : 0,
            "&:first-child": {
                marginLeft: "0px !important;",
            },
            whiteSpace: 'nowrap'
        }, 
        complexButtonPopper: {
            minWidth: '130px'
        },
        complexButtonLeft: {
            width: '90%'
        },
        complexButtonMenuItem: {
            display: "flex",
            justifyContent: 'center'
        },
        complexButtonMenuList: {
            // display: "flex",
            // justifyContent: 'center'
        },
        complexButtonCarrot: {
            width: '10%'
        },
        getNextButton: {
        width: 120,
        paddingLeft: 2,
        whiteSpace: 'nowrap',
        //   marginLeft: theme.spacing(),
        "&:first-child": {
            marginLeft: "0px !important;",
        }
    }, 
    getNextIcon: {
        marginRight: 5,
        fontSize: "inherit"
    },
    actionsContainer: {
        marginBottom: 10
    }
  })
);

interface FormBasedActionsProps {
    actionDefinition: any;
    setActionDefinition?: any;
    handleAction: (actionRequest: any)=>void;
    mode?: string;
    getNextAvailable?: boolean;
    getNextEnabled: boolean;
    setGetNextEnabled: any;
    disableGutters?: boolean;
}

export const FormBasedActions: React.FC<FormBasedActionsProps> = ({
    disableGutters,
    actionDefinition,
    setActionDefinition,
    mode,
    getNextAvailable,
    getNextEnabled,
    setGetNextEnabled,
    handleAction,
    task
}) => {
    const classes = useStyles();

    const [fullData, setFullData] = useContext(DataContext);
    const [initAction, setInitAction] = useContext(ActionContext);

    const [complexOpen, setComplexOpen] = useState(-1)
    const [anchorEl, setAnchorEl] = useState(undefined)

    const toggleGetNext = () => {
        setGetNextEnabled(!getNextEnabled)
    }

    const getButtonColor = (action: any) => {
        if (action.buttonOptions && action.buttonOptions.color) {
            if (action.buttonOptions.color == "default") {
                return "inherit"
            }
            return action.buttonOptions.color
        }
        return "inherit"
    }

    const getButtonStyle = (action: any) => {
        if (action.buttonOptions && action.buttonOptions.styleAttributes) {
            return action.buttonOptions.styleAttributes
        }
        return {}
    }

    const handleComplexButtonToggle = (idx, event) => {
        var anchorEl = null

        if (complexOpen != idx ) {
            anchorEl = event.currentTarget.parentElement
        }

        if (complexOpen == idx) {
            idx = -1
        }

        setComplexOpen(idx)
        setAnchorEl(anchorEl)
    }

    const handleComplexButtonClose = () => {
        setComplexOpen(-1)
        setAnchorEl(undefined)
    }

    const getActionNotification = (param: string): Promise<any> => {
        return new Promise((resolve, reject) => {
            
            param = param.replace("$", "")
            var parts = param.split("|")
                        
            if (parts[1]){
                var content = 0
                switch (parts[1]) {
                    case 'count':
                        var subParts = parts[0].split("+")
                        for (let subPart of subParts) {
                            var evalVal = getValueAtPath(subPart, fullData)
                            if (evalVal) {
                                content = content + evalVal.length
                            }	
                        }
                                                
                        resolve({body: {count: content}})
                        
                        break
                    case 'sum':
                        break
                }
            } else if (evalVal) {
                resolve({body: {count: evalVal.string()}})
            }
        });
    }

    const setNotificationValues = (actionDefinition: any) => {
        var promises = Array<any>()
        var definitionSet
        var idx = 0;
        var pidx = Array<any>()
        if (actionDefinition.definition) {
            if (mode != "" && actionDefinition.definition[mode]) {
                definitionSet = actionDefinition.definition[mode]
            } else {
                definitionSet = actionDefinition.definition.actions 
            }
            if (definitionSet) {
            
                for (let action of definitionSet) {
                    if (action.notificationFulfillment && !action.notificationValue && action.notificationValue != 0) {
                        if (action.notificationFulfillment.startsWith("/")) {
                            promises.push(request.get(action.notificationFulfillment))
                            pidx.push(idx)
                        } else if (action.notificationFulfillment.startsWith("$")) {
                            promises.push(getActionNotification(action.notificationFulfillment))
                            pidx.push(idx)
                        }
                        
                    }
                    idx++
                }
            }
        }
        if (promises.length > 0) {
            Promise.all(promises)
            .then((values) => {
                // Eventually, we may want to look into non-200 error codes, especially 205 for init data on "/new" routes
                var promiseIdx = 0

                var ad = cloneDeep(actionDefinition)

                for (let value of values) {
                    var actionIdx = pidx[promiseIdx]
                    if (value && value.body) {

                        if (ad.definition) {
                            if (mode != "" && ad.definition[mode]) {
                                ad.definition[mode][actionIdx].notificationValue = value.body.count
                            } else {
                                ad.definition.actions[actionIdx].notificationValue = value.body.count
                            }
                        }
                        
                    }
                    promiseIdx++ 
                }
                
                setActionDefinition(ad)
            })
            .catch((err) => {
                // probably nothing we can do here... the notification should not show
                console.error("err", err)
            });
        } 
    }

    const buildActions = () => {
        var pullLeft = Array<any>()
        var actions = Array<any>()
        var definitionSet

        if (actionDefinition.definition) {
            if (mode != "" && actionDefinition.definition[mode]) {
                definitionSet = actionDefinition.definition[mode]
            } else {
                definitionSet = actionDefinition.definition.actions 
            }
            if (definitionSet) {
                var defaultActions = definitionSet.filter((ad: any)=>{return !ad.buttonOptions.pullLeft})
                actions = defaultActions.map((a: any, idx)=>{
                    a = interpolateAction(a, fullData)
                    var renderPopper = false

                    if (idx == complexOpen) {
                        renderPopper = true
                    }
                    var badgeContent 
                    var badgeColor = "primary"
                    if (a.notificationValue){
                        badgeContent = a.notificationValue
                    }
                    if (a.notificationColor){
                        badgeColor = a.notificationColor
                    }
                    if (!a.submitAction && a.mode != "Hidden") {

                        if (a.subActions) {
                            // Drop hidden sub-actions. NOTE: do not splice while iterating with a
                            // fixed index — filter rebuilds the array so the correct entries are removed
                            // regardless of position (previously always removed index 0).
                            a.subActions = a.subActions.filter((subAction: any) => !(subAction.mode && subAction.mode == "Hidden"))
                        }
                        // Render button or complex button, depending on if any subactions remain that aren't hidden
                        if (a.subActions && a.subActions.length > 0) {
                        return (
                        <Badge key={idx + a.title} color={badgeColor} anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}  className={classes.actionButtonComplex} badgeContent={badgeContent} invisible={!badgeContent}>
                        <ButtonGroup className={classes.actionButtonComplex} variant="contained" color={getButtonColor(a)} style={getButtonStyle(a)} aria-label="split button"> 
                        <Button className={classes.complexButtonLeft} onClick={(a.dispatchChannel || (a.dialogueOptions && (a.dialogueOptions.formSelector || a.dialogueOptions.renderer))) ? _handleAction.bind(this, a) : handleComplexButtonToggle.bind(this, idx)}>{a.title}</Button>
                        <Button
                            color={getButtonColor(a)}
                            size="small"
                            className={classes.complexButtonCarrot}
                            aria-controls={renderPopper ? 'split-button-menu' : undefined}
                            aria-expanded={renderPopper ? 'true' : undefined}
                            aria-haspopup="menu"
                            onClick={handleComplexButtonToggle.bind(this, idx)}
                        >
                            <ArrowDropDownIcon />
                        </Button>
                        </ButtonGroup>
                        <Popper open={renderPopper} className={classes.complexButtonPopper} role={undefined} anchorEl={anchorEl} transition disablePortal>
                        {({ TransitionProps, placement }) => (
                            <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                            }}
                            >
                            <Paper
                            style={{
                                overflow: 'auto'
                              }}>
                                <ClickAwayListener onClickAway={handleComplexButtonClose}>
                                <MenuList id="split-button-menu" className={classes.complexButtonMenuList}>
                                    {a.subActions.map((subA, index) =>  (                           
                                        <MenuItem
                                            key={subA}
                                            className={classes.complexButtonMenuItem}
                                            // disabled={index === 2}
                                            onClick={_handleAction.bind(this, subA)}
                                        >
                                            {subA.title}
                                        </MenuItem>
                                        )

                                    )}
                                </MenuList>
                                </ClickAwayListener>
                            </Paper>
                            </Grow>
                        )}
                        </Popper>
                    </Badge>)
                    } else {
                        return (
                            <Badge key={idx + a.title} color={badgeColor} className={classes.actionButton} anchorOrigin={{vertical: 'bottom', horizontal: 'left'}} badgeContent={badgeContent} invisible={!badgeContent}>
                            <Button
                            variant="contained"
                            onClick={_handleAction.bind(this, a)}
                            color={getButtonColor(a)}
                            className={classes.actionButton}
                            style={getButtonStyle(a)}
                            >
                            {a.title}
                            </Button>
                            </Badge>
                        )
                        }
                    }
                    
                }) 

                var pullLeftActions = definitionSet.filter((ad: any)=>{return ad.buttonOptions.pullLeft})
                pullLeft = pullLeftActions.map((a: any, idx)=>{
                    a = interpolateAction(a, fullData)
                    var badgeContent
                    var badgeColor = "primary"

                    if (a.notificationValue){
                        badgeContent = a.notificationValue
                    }
                    if (a.notificationColor){
                        badgeColor = a.notificationColor
                    }
                    if (!a.submitAction && a.mode != "Hidden") {
                    return (
                        <Badge key={idx + a.title} color={badgeColor} className={classes.actionButton} anchorOrigin={{vertical: 'bottom', horizontal: 'left'}} badgeContent={badgeContent} invisible={!badgeContent}>
                            <Button
                            variant="contained"
                            onClick={_handleAction.bind(this, a)}
                            color={getButtonColor(a)}
                            className={classes.actionButton}
                            style={getButtonStyle(a)}
                            >
                            {a.title}
                            </Button>
                        </Badge>
                    )
                    }
                    
                })
            }
        }
        return {
            actions: actions,
            pullLeft: pullLeft
        }
    }

    const _handleAction = (action: any) => {
        if (complexOpen != -1){
            handleComplexButtonClose()
        }
        if (handleAction) {
            handleAction(action)
        }
        setNotificationValues(actionDefinition)
        
    }

    useEffect(() => {
        // Init action will be null when not set.
        if (initAction) {
            handleAction(initAction)
            setInitAction(null)
        }
    }, [initAction])


    useEffect(() => {
        setNotificationValues(actionDefinition)
    }, [])

    useEffect(() => {
        setNotificationValues(actionDefinition)
    }, [mode, task])

    var actionbar = buildActions()
    
    return (
        <AppBar elevation={1} position={"static"} className={classes.appbar}>
            <Toolbar disableGutters={disableGutters} className={classes.toolbar}>

                {mode == "" && getNextAvailable && <Button
                    onClick={toggleGetNext}
                    color={"inherit"}
                    className={classes.getNextButton}
                    variant="contained"
                    key="getNext"
                >
                    {getNextEnabled ? <RadioButtonChecked fontSize={"small"} className={classes.getNextIcon}/> : <RadioButtonUnchecked fontSize={"small"} className={classes.getNextIcon}/>}Get Next
                </Button>}

                {actionbar.pullLeft}

                <div style={{flex:1}}></div>

                {actionbar.actions}

            </Toolbar>
        </AppBar>
    );
};

export default FormBasedActions;
